import { createParser } from 'nuqs';

export const parseAsBoolean = createParser<boolean | null>({
  parse(queryValue: string) {
    const normalized = queryValue.trim().toLowerCase();

    if (normalized === 'true') return true;
    if (normalized === 'false') return false;

    return null;
  },
  serialize(value: boolean | null) {
    if (value === null) {
      return '';
    }

    return value ? 'true' : 'false';
  },
});

export const parseAsStringArray = createParser<string[] | null>({
  parse(queryValue: string) {
    if (!queryValue) {
      return [];
    }

    const values = queryValue
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

    return values.length > 0 ? values : [];
  },
  serialize(value: string[] | null) {
    if (!value || value.length === 0) {
      return '';
    }

    return value.join(',');
  },
});

export type TechnologyHeaderTab = 'cyber' | 'details' | 'ma' | 'mrl' | 'organization' | 'overview' | 'trl';

export const parseAsTechnologyHeaderTab = createParser<TechnologyHeaderTab>({
  parse(queryValue: string): TechnologyHeaderTab | null {
    const normalized = queryValue.trim().toLowerCase();

    if (normalized === 'cyber') return 'cyber';
    if (normalized === 'details') return 'details';
    if (normalized === 'ma') return 'ma';
    if (normalized === 'mrl') return 'mrl';
    if (normalized === 'organization') return 'organization';
    if (normalized === 'overview') return 'overview';
    if (normalized === 'tech') return 'overview';
    if (normalized === 'trl') return 'trl';

    return null;
  },
  serialize(value: TechnologyHeaderTab): string {
    return value;
  },
});

export type TrlSubTab = 'individual' | 'overview' | 'projection';

export const parseAsTrlSubTab = createParser<TrlSubTab>({
  parse(queryValue: string): TrlSubTab | null {
    const normalized = queryValue.trim().toLowerCase();

    if (normalized === 'overview') return 'overview';
    if (normalized === 'individual') return 'individual';
    if (normalized === 'projection') return 'projection';

    return null;
  },
  serialize(value: TrlSubTab): string {
    return value;
  },
});

export type MrlSubTab = 'overview' | 'individual';

export const parseAsMrlSubTab = createParser<MrlSubTab>({
  parse(queryValue: string): MrlSubTab | null {
    const normalized = queryValue.trim().toLowerCase();

    if (normalized === 'overview') return 'overview';
    if (normalized === 'individual') return 'individual';

    return null;
  },
  serialize(value: MrlSubTab): string {
    return value;
  },
});
